
import React from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Globe, Users } from 'lucide-react';
import DomainsTabContent from './DomainsTabContent';
import SuperAdminsTabContent from './SuperAdminsTabContent';
import { LicenseKey } from '@/types/licenseKey';

interface DashboardTabsProps {
  domains: any[];
  superAdminLicenses: any[];
  licenseKeys: LicenseKey[];
}

const DashboardTabs: React.FC<DashboardTabsProps> = ({ 
  domains, 
  superAdminLicenses, 
  licenseKeys 
}) => {
  return (
    <div className="mb-8">
      <Tabs defaultValue="domains">
        <TabsList className="grid w-full grid-cols-2">
          <TabsTrigger value="domains">
            <Globe className="mr-2 h-4 w-4" />
            Domains
          </TabsTrigger>
          <TabsTrigger value="superadmins">
            <Users className="mr-2 h-4 w-4" />
            Super Admins
          </TabsTrigger>
        </TabsList>
        <TabsContent value="domains">
          <DomainsTabContent domains={domains} licenseKeys={licenseKeys} />
        </TabsContent>
        <TabsContent value="superadmins">
          <SuperAdminsTabContent superAdminLicenses={superAdminLicenses} licenseKeys={licenseKeys} />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default DashboardTabs;
